/**
 * DpRouteGate — signed-in access follows the launcher catalog (`decisionpoint`).
 * Signed-out and anonymous visitors pass through (pages send them to sign-in).
 * Restricted-host redirects stay on the route table in AppRoutes.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Container } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';
import Loading from 'components/Loading';
import { getAppsForUser } from 'components/appLauncher/appCatalog';
import { useLauncherAuthState } from 'components/appLauncher/useLauncherAuthState';

export default function DpRouteGate({ children }) {
  const { user, userLoading } = useAuth();
  const { authState, loading } = useLauncherAuthState();

  const isRealAccount = Boolean(user) && !user?.isAnonymous;

  if (userLoading || (isRealAccount && loading)) return <Loading page />;

  if (!isRealAccount) {
    return children ?? <Outlet />;
  }

  const allowed = getAppsForUser(authState).some((app) => app.id === 'decisionpoint');
  if (!allowed) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Alert severity="info" data-testid="launcher.guard.denied">
          This app is not available for your account.
        </Alert>
      </Container>
    );
  }

  return children ?? <Outlet />;
}

DpRouteGate.propTypes = {
  children: PropTypes.node,
};
